<!--
 * @Description: Description
 * @Author: dpw
 * @Date: 2025-01-216 11:46:23
 * @LastEditors: gaoyuanyuan
 * @LastEditTime: 2026-03-30 14:30:41
-->
<template>
    <div :class="['register-page', $i18n.locale]">
        <div class="navbar">
            <el-dropdown placement="bottom" class="custom-dropdown" @command="onCommand" trigger="click">
                <span class="el-dropdown-language">{{ currentLanguage }}</span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item
                        :command="item.label"
                        v-for="(item, index) in languages"
                        :key="index"
                        :disabled="item.label === currentLanguage"
                        >{{ item.label }}</el-dropdown-item
                    >
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="header">
            <h2>{{ $t('login.newEmailLogin') }}</h2>
            <p>{{ $t('login.loginTips') }}</p>
        </div>
        <!-- 邮箱密码登录 -->
        <div class="content" v-if="loginStatus">
            <div class="form">
                <div class="item">
                    <label for="email" v-if="$i18n.locale === 'tr-TR' || $i18n.locale === 'ar-AR'">{{
                        $t('login.email')
                    }}</label>
                    <label for="email" v-else>E-mail</label>
                    <div class="info">
                        <van-field
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            v-model.trim="form.email"
                            name
                            label
                            :placeholder="$t('login.formList[2].label')"
                            class="iteminput"
                        />
                    </div>
                </div>
                <div class="item">
                    <label for="verifyPassword" class="codeLabel codeLabel-item">{{
                        $t('login.account.password')
                    }}</label>
                    <div class="info">
                        <input
                            :style="
                                $i18n.locale === 'zh-CN'
                                    ? 'padding-left: 50px'
                                    : $i18n.locale === 'es-ES' ||
                                      $i18n.locale === 'it-IT' ||
                                      $i18n.locale === 'cz-CZ' ||
                                      $i18n.locale === 'tr-TR' ||
                                      $i18n.locale === 'el-GR'
                                    ? 'padding-left: 10px'
                                    : 'padding-left: 20px'
                            "
                            autocomplete="off"
                            ref="verifyPassword"
                            v-model="form.password"
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            @input="validatorPassword"
                            :type="isAppleDevice ? (showPassword ? 'text' : 'password') : 'text'"
                            label
                            :placeholder="$t('login.account.placeholder')"
                            name="verifyPassword"
                            :border="false"
                            :class="[
                                isAppleDevice ? '' : showPassword ? 'password-visible' : 'password-hidden',
                                'itemyzm',
                            ]"
                        />

                        <span class="toggle-password" @click="togglePassword">
                            <img
                                :src="
                                    showPassword
                                        ? require('@/assets/images/eye_show.png')
                                        : require('@/assets/images/eye_off.png')
                                "
                                class="eye-icon"
                            />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 邮箱验证码登录 -->
        <div class="content" v-else>
            <div class="form">
                <div class="item">
                    <label for="email" v-if="$i18n.locale === 'tr-TR' || $i18n.locale === 'ar-AR'">{{
                        $t('login.email')
                    }}</label>
                    <label for="email" v-else>E-mail</label>
                    <div class="info">
                        <van-field
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            v-model.trim="form.email"
                            name
                            label
                            :placeholder="$t('login.formList[2].label')"
                            class="iteminput"
                        />
                    </div>
                </div>
                <div class="item">
                    <label for="verifyCode" class="codeLabel codeLabel-item">{{ $t('login.formList[1].label') }}</label>
                    <div class="info">
                        <!-- <div class="placeholder_code" v-if="!isFocus && $i18n.locale === 'ja-JP'"
                            @click="onPlaceholder">
                            {{ $t('login.formList[1].placeholder') }}
                        </div>-->
                        <input
                            :style="
                                $i18n.locale === 'zh-CN'
                                    ? 'padding-left: 50px'
                                    : $i18n.locale === 'es-ES' || $i18n.locale === 'it-IT' || $i18n.locale === 'tr-TR'
                                    ? 'padding-left: 10px'
                                    : 'padding-left: 20px'
                            "
                            autocomplete="off"
                            ref="verifyCode"
                            :disabled="isCodeInputDisabled"
                            v-model="form.code"
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            @input="validatorCode"
                            type="number"
                            label
                            :placeholder="$t('login.formList[1].placeholder')"
                            name="verifyCode"
                            :border="false"
                            class="itemyzm"
                        />
                        <span
                            :class="{ 'is-disabled': isCodeBtnDisabledEmail }"
                            @click="handleSendCode"
                            class="get-code-btn"
                            >{{ codeText }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div class="login-tool">
                <div class="left-view">
                    <img
                        :src="require('@/assets/images/login/toggle_button.png')"
                        class="image"
                        @click="switchLoginType"
                    />
                    <div class="name" @click="switchLoginType">
                        {{ !loginStatus ? $t('login.emailPassword') : $t('login.emailCode') }}
                    </div>
                </div>

                <div v-if="loginStatus" class="name-view" @click="forgotPassword">
                    {{ $t('login.account.forgotPassword') }}
                </div>
            </div>

            <div :class="['agreement', $i18n.locale]">
                <span :class="[{ 'is-check': isSelectRule }, 'checkbox']" @click="onRuleChange">
                    <input type="checkbox" v-model="isSelectRule" />
                </span>
                <i>{{ $t('register.needRead.agree') }}</i>
                <span @click="goToUser('UserSecret')">{{ $t('register.needRead.privacy') }}</span>
            </div>

            <div class="submit-btn">
                <div class="error-tips" v-if="erorTips">{{ erorTips }}</div>
                <van-button
                    :disabled="isMobileSubmitDisabled"
                    :class="{
                        'is-disabled': isMobileSubmitDisabled,
                        'custom-btn': true,
                    }"
                    @click.prevent="loginClick"
                    @keyup.enter="loginClick"
                    type="primary"
                    color="linear-gradient(90deg, #00E3C9 0%, #009FE8 100%)"
                    >{{ $t('login.account.accountTitle') }}</van-button
                >
            </div>
        </div>

        <!-- 自动登录 -->
        <div class="automatic-login" @click="isAutoLogin = !isAutoLogin">
            <span :class="[{ 'is-check': isAutoLogin }, 'checkbox']">
                <input type="checkbox" v-model="isAutoLogin" />
            </span>
            <i>{{ $t('login.autoLogin') }}</i>
        </div>

        <!-- 其他登录方式 -->
        <div class="third-view">
            <div class="line-view">
                <div class="line"></div>
                <div class="tips-view">{{ $t('login.otherLogin') }}</div>
                <div class="line"></div>
            </div>

            <div class="third-login">
                <div v-if="googleLoginState" @click="thirdLoginClick(1)">
                    <img
                        :src="require('@/assets/images/login/google.png')"
                        class="button"
                        style="margin: 0 8px 0 8px"
                    />
                </div>
                <div v-if="faceBookLoginState" @click="thirdLoginClick(2)" style="margin: 0 8px 0 8px">
                    <img :src="require('@/assets/images/login/facebook.png')" class="button" />
                </div>
                <div v-if="loginStatus">
                    <img
                        v-if="!showPhoneLogin"
                        :src="require('@/assets/images/login/other_login.png')"
                        class="button"
                        style="margin: 0 8px 0 8px"
                        @click="showPhoneLoginClick()"
                    />
                    <div v-else>
                        <img
                            :src="require('@/assets/images/login/phone.png')"
                            class="button"
                            style="margin: 0 8px 0 8px"
                            @click="thirdLoginClick(3)"
                        />
                        <img
                            :src="require('@/assets/images/login/close_icon.png')"
                            class="button"
                            @click="showPhoneLoginClick()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="loading-overlay">
            <van-loading :size="50" type="circular" color="rgb(100, 100, 100)" />
        </div>
        <div class="dialog">
            <van-dialog v-model="isToRegister" :show-confirm-button="false">
                <template slot="title">{{ $t('login.account.errorTips[2]') }}</template>
                <div class="tips">
                    <p>{{ $t('login.accountDoesNotExist', { item: getGoogleOrFaceBookLogin }) }}</p>
                </div>
                <div class="btns">
                    <van-button class="dialog-cancel" @click="onCancel">{{ $t('sidebar.btn.cancelBtn') }}</van-button>
                    <div class="dialog-confirm">
                        <van-button @click="toRegisterClick" class="dialog-confirm">
                            {{ $t('login.toRegister') }}
                        </van-button>
                    </div>
                </div>
            </van-dialog>
        </div>
    </div>
</template>
<script>
import {
    accountLogin,
    findScanTypeInfoheightByScanId,
    getThirdLoginUrl,
    sendValidationEmail,
    smsLogin,
    thirdLogin,
    getMapToken,
} from '@/assets/js/apolloGql.js'
import {
    cryptographicCheck,
    singleCryptographicCheck,
    encryptPassword,
    parseAuthCallback,
    cacheThirdToken,
    getCacheThirdToken,
    checkEmailBound,
} from '@/assets/js/util.js'
import { shareTime, faceBookLogin, googleLogin } from '@/assets/js/config.js'
import { languageConfig, languageConfigM60 } from '@/assets/js/langObject'
import { isM60 } from '@/types/device.js'

export default {
    components: {},
    data() {
        return {
            isFocus: false,
            erorTips: '',
            iphoneResult: '',
            isAutoLogin: true,
            areaCode: '',
            currentLanguage: '',
            languages: isM60() ? languageConfigM60 : languageConfig,
            form: {
                code: '',
                phone: '',
                email: '',
                password: '',
            },
            height: {
                isValid: false,
                value: '',
            },
            birthday: {
                isValid: false,
                year: '',
                month: '',
                day: '',
            },
            // 验证码定时器
            timer: '',
            // 获取验证码时间间隔 60s
            countDown: 60,
            codeText: '',
            // 验证码默认不能输入 验证码发送成功后才能输入
            isCodeInputDisabled: false,
            // 验证码是否正在发送状态
            isCodeSending: false,
            outTimeStamp: 0,
            // 错误信息
            errorMg: '-',
            // 提交按钮状态
            submitDisabled: false,
            // 按钮开关
            isBtnHand: true,
            loginInfo: JSON.parse(window.localStorage.getItem('loginInfo')),
            // 选择登录状态
            loginStatus: false,
            timeTag: null,
            qkStatus: false,
            // 登录按钮是否正在加载中
            loginBtnState: false,
            userId: '',
            scanId: '',
            userType: 0, // egym 0 代表，当前无手机号邮箱   1   手机号   2 邮箱
            showPassword: false, // 用于控制密码显示/隐藏
            loading: false, // 第三方登录loading
            // 是否勾选同意协议
            isSelectRule: true,
            isMobileSubmitDisabled: true,
            showPhoneLogin: false,
            isToRegister: false,
        }
    },

    computed: {
        // 是否禁用获取验证码按钮 手机号长度不对|正在倒计时|验证码已发送等待返回
        isCodeBtnDisabled() {
            return this.isCodeSending
        },
        isAppleDevice() {
            return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)
        },
        isCodeBtnDisabledEmail() {
            return !this.form.email
        },
        // 是否禁用登录按钮
        // isMobileSubmitDisabled() {
        //      if(!this.loginStatus){
        //         return this.form.code.length !== 4
        //     }
        //     return !cryptographicCheck(this.form.password)
        // },
        // 是否禁用用户信息注册按钮
        isSubmitDisabled() {
            return this.birthday.isValid === false || this.height.isValid === false
        },
        userAgent() {
            const ua = navigator.userAgent
            return {
                ua: ua,
                isAndroid: ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1,
                isiOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            }
        },
        faceBookLoginState() {
            return faceBookLogin === 'true'
        },
        googleLoginState() {
            return googleLogin === 'true'
        },
        getGoogleOrFaceBookLogin() {
            let str = ''
            if (this.googleLoginState) {
                str = 'Google'
            }
            if (str.length > 0 && this.faceBookLoginState) {
                str = str + '/' + 'Facebook'
            } else {
                str = str + 'Facebook'
            }
            return str
        },
    },

    watch: {},

    beforeDestroy() {
        clearInterval(this.timer)
    },
    created() {
        // 分享链接处理
        window.localStorage.removeItem('BmLastScanId')
        let url = window.location.href
        const data = parseAuthCallback(url)
        console.log(data)
        // 单位默认值为公制单位
        const unit = localStorage.getItem('unit')
        if (!unit) {
            localStorage.setItem('unit', 'metric')
        }
        // 默认语言配置
        const lang = localStorage.getItem('lang')
        if (!lang) {
            localStorage.setItem('lang', 'en-US')
        }

        console.log(`语言配置${JSON.stringify(languageConfig)}`)
        this.codeText = this.$t('login.formList[0].placeholder')
        this.areaCode = this.languages.find((item) => item.value === this.$i18n.locale)?.no
        this.currentLanguage = this.languages.find((item) => item.value === this.$i18n.locale)?.label
        if (data && data.state && data.accessToken) {
            if (data.state.scanId) {
                this.findScanTypeInfoheightByScanId(data.state.scanId)
            }
            cacheThirdToken(data)
            this.userId = data.state.userId
            if (data.state.query.redirect) {
                localStorage.setItem('redirect', data.state.query.redirect || '/report')
            }
            this.thirdLogin(data.state.type, data.accessToken, data.state.query, data.state.userId)
        } else {
            // 保存参数
            if (this.$route.query.redirect === '/report/historyPage') {
                localStorage.setItem('redirect', '/report')
            } else {
                localStorage.setItem('redirect', this.$route.query.redirect || '/report')
            }
            this.getShareToken(url)
            var userAgent = navigator.userAgent
            if (userAgent.indexOf('Quark') > -1) {
                this.qkStatus = true
            }
            // 没有注册界面（登录界面会自动注册）
            // const register = this.$route.query.register
            // if (register) {
            //     this.toRegister()
            // }
            // egym开发流程
            const urlObj = new URL(url)
            const redirectParam = urlObj.searchParams.get('redirect')
            if (redirectParam) {
                // 解码嵌套参数
                const nestedParams = new URLSearchParams(redirectParam.split('?')[1])
                this.userType = parseInt(nestedParams.get('user_type'))
                this.userId = nestedParams.get('user_id')
                this.scanId = nestedParams.get('scan_id')
                console.log(this.userType, this.userId, 88888)
                if (this.userId && this.userId.length > 0) {
                    // egym 客户登录使用验证码登录
                    this.loginStatus = false
                }
            }
        }
    },
    mounted() {
        // 保留信息不被清空
        const lookUserInfo = JSON.parse(window.localStorage.getItem('lookUserInfo'))
        if (lookUserInfo) {
            this.form.phone = lookUserInfo.phone
            this.form.code = lookUserInfo.code
            this.form.email = lookUserInfo.email
            this.countDownTime = lookUserInfo.countDownTime || 0
            this.isCodeInputDisabled = false
            const time = new Date().getTime() - this.countDownTime
            if (time < 60000) {
                this.isCodeSending = true
                this.countDown = 60 - Math.floor(time / 1000)
                this.countDownAction()
            }
        }

        // egym进行登录选择
        switch (this.userType) {
            case 1:
                // 手机登录
                this.$router.push({
                    path: '/phoneLogin',
                    query: { redirect: this.$route.query.redirect || '/exception/report' }, // 'to.fullPath'跳转到登录之前页面的路径
                })
                break
            case 2:
                // 邮箱登录
                break
            default:
                break
        }
        this.findScanTypeInfoheightByScanId(null)
    },

    methods: {
        goToUser(pathName) {
            this.$router.push({
                name: pathName,
            })
        },
        mobileSubmitDisabled() {
            if (!this.loginStatus) {
                this.isMobileSubmitDisabled = this.form.code.length !== 4
            }
            if (this.loginStatus) {
                this.isMobileSubmitDisabled = !cryptographicCheck(this.form.password)
            }
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },
        onRuleChange() {
            this.isSelectRule = !this.isSelectRule
            if (this.isSelectRule) {
                this.erorTips = ''
            }
        },
        // 校验密 码
        validatorPassword() {
            const newPassword = event.target.value.replace(/[\u4e00-\u9fa5]/g, '')
            // 使用 Vue.set 确保响应式更新
            this.$set(this.form, 'password', newPassword)
            this.$nextTick(() => {
                if (this.form.password.length < 4) {
                    this.erorTips = ''
                    return
                }
                const data = singleCryptographicCheck(this.form.password)
                if (!data.length) {
                    this.erorTips = this.$t('login.account.checkRule[0]')
                } else if (!data.uppercase) {
                    this.erorTips = this.$t('login.account.checkRule[1]')
                } else if (!data.lowercase) {
                    this.erorTips = this.$t('login.account.checkRule[2]')
                } else if (!data.digit) {
                    this.erorTips = this.$t('login.account.checkRule[3]')
                } else {
                    this.erorTips = ''
                }
            })
            this.mobileSubmitDisabled()
        },

        // 切换密码验证登录
        switchLoginType() {
            this.erorTips = ''
            this.loginStatus = !this.loginStatus
            this.form.code = ''
            this.form.password = ''
            this.isMobileSubmitDisabled = true
        },

        onPlaceholder() {
            this.isFocus = true
            this.$nextTick(() => {
                console.log(this.$refs.verifyCode)
                this.$refs.verifyCode.focus()
            })
        },
        onCommand(lang) {
            let languageInfo = {}
            for (let index = 0; index < this.languages.length; index++) {
                if (lang === this.languages[index].label) {
                    languageInfo = this.languages[index]
                    break
                }
            }
            this.$i18n.locale = languageInfo.value
            this.areaCode = languageInfo?.no
            localStorage.setItem('lang', this.$i18n.locale)
            this.currentLanguage = lang
            this.codeText = this.$t('login.formList[0].placeholder')
            this.erorTips = ''
            this.form.phone = ''
            this.form.code = ''
            this.form.email = ''
            this.form.password = ''
        },
        // 失去焦点后重置背景
        handleBlurReset(e) {
            this.resetBackground()
            const email = this.form.email
            if (email === '') {
                this.$toast({
                    message: this.$t('login.formList[2].label'),
                    duration: 1500,
                    className: 'success-toast',
                })
                return
            }
            // eslint-disable-next-line no-useless-escape
            const emailStr =
                // eslint-disable-next-line no-useless-escape
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!emailStr.test(this.form.email)) {
                this.erorTips = this.$t('login.rule.email.requiredMsg')
            } else {
                this.erorTips = ''
            }

            if (this.form.password === '') {
                this.isFocus = false
            }
            this.outTimeStamp = e.timeStamp
            setTimeout(() => {
                if (this.outTimeStamp === e.timeStamp) {
                    this.resetBackground()
                }
            }, 100)
        },

        handleFouceReset(e) {
            this.outTimeStamp = e.timeStamp
        },

        // 重置iso下键盘收回后底部空白问题
        resetBackground() {
            window.scrollTo(0, 0)
        },
        // 跳转注册页面
        jumpRegis() {
            const setTimer = setTimeout(() => {
                this.toRegister()
                window.clearTimeout(setTimer)
            }, 1000 * 1)
        },
        validateForm() {
            let err
            if (this.loginStatus && !this.form.password) {
                err = this.$t('login.formList[1].placeholder')
            }
            if (this.loginStatus && this.form.password) {
                let data = singleCryptographicCheck(this.form.password)
                if (!data.length) {
                    err = this.$t('login.account.checkRule[0]')
                }
                if (!data.uppercase) {
                    err = this.$t('login.account.checkRule[1]')
                }
                if (!data.lowercase) {
                    err = this.$t('login.account.checkRule[2]')
                }
                if (!data.digit) {
                    err = this.$t('login.account.checkRule[3]')
                }
            }
            if (!this.form.email) {
                err = this.$t('login.formList[2].label')
            } else {
                // eslint-disable-next-line no-useless-escape
                const email =
                    // eslint-disable-next-line no-useless-escape
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (!email.test(this.form.email)) {
                    err = this.$t('login.rule.email.requiredMsg')
                }
            }
            if (err) {
                this.erorTips = err
                return false
            }
            return true
        },
        // 倒计时
        countDownAction() {
            this.countDownTime = new Date().getTime()
            let that = this
            this.timeTag = setInterval(() => {
                that.countDown--
                that.codeText = `${this.$t('login.retransmission', { item: that.countDown })}`
                if (that.countDown === 0) {
                    that.isCodeSending = false
                    that.codeText = this.$t('login.formList[0].placeholder')
                    clearInterval(this.timeTag)
                    that.countDown = 60
                }
            }, 1000)
            this.timer = this.timeTag
        },

        // 发送验证码
        async handleSendCode() {
            let that = this
            // 判断按钮状态 禁用时不可点击
            console.log(that.isCodeBtnDisabled)
            if (this.isCodeBtnDisabled) {
                return
            }
            that.form.code = ''
            const reg = /^[0-9]*$/
            // eslint-disable-next-line no-useless-escape
            const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (this.countDown === 60) {
                if (!reg.test(this.form.phone) && this.loginStatus) {
                    this.erorTips = this.$t('login.rule.phone.requiredMsg')
                } else if (!email.test(this.form.email) && !this.loginStatus) {
                    this.erorTips = this.$t('login.rule.email.requiredMsg')
                } else {
                    this.isCodeSending = true
                    // 验证码发送成功后可输入验证码
                    this.isCodeInputDisabled = false
                    this.$apollo
                        .mutate({
                            mutation: sendValidationEmail,
                            variables: {
                                email: this.form.email,
                            },
                        })
                        .then((res) => {
                            const data = res.data.sendValidationEmail
                            if (data.code === 200) {
                                this.countDownAction()
                                this.$toast({
                                    message: this.$t('login.success'),
                                    duration: 2000,
                                    className: 'success-toast',
                                })
                            } else if (data.code === 404) {
                                // 邮箱未注册提示文案
                                this.erorTips = this.$t('login.rule.email.patternMsg')
                            } else {
                                this.isCodeSending = false
                                this.$toast({
                                    message: this.$t('login.error'),
                                    duration: 1500,
                                    className: 'success-toast',
                                })
                            }
                        })
                        .catch((err) => {
                            console.error(err)
                            this.isCodeSending = false
                        })
                }
            }
        },
        loginClick() {
            console.log(this.loginStatus)
            if (!this.isSelectRule) {
                this.$toast({
                    message: this.$t('register.check'),
                    duration: 2000,
                    className: 'success-toast',
                })
                return
            }
            if (!this.loginStatus) {
                // 验证码登录
                this.codeLogin()
            } else {
                // 密码登录
                this.passwordLogin()
            }
        },
        // 密码登录
        passwordLogin() {
            if (!this.isMobileSubmitDisabled && this.validateForm() && !this.loginBtnState) {
                this.loginBtnState = true
                let mobile = ''
                if (this.form.phone) {
                    // 去除手机号中的所有前导零
                    let cleanedPhone = this.form.phone.replace(/^0+/, '')
                    mobile = this.areaCode + cleanedPhone
                }
                this.$apollo
                    .query({
                        query: accountLogin,
                        fetchPolicy: 'network-only',
                        variables: {
                            mobile: '',
                            email: this.form.email,
                            password: encryptPassword(this.form.password),
                            userId: this.userId,
                        },
                    })
                    .then((res) => {
                        const data = res.data.accountLogin
                        console.log(data)
                        // 老用户 已有用户信息
                        if (data.code === 200) {
                            this.jumpReportPage({ ...data.data, email: this.form.email }, mobile, null)
                        } else if (data.code === 403) {
                            // 密码错误
                            console.log(`${data.message}`)
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.account.errorTips[0]')
                        } else if (data.code === 404) {
                            // 没有注册 账号不存在，
                            this.loginBtnState = false
                            this.isToRegister = true
                            // this.erorTips = this.$t('login.bindError[9]')
                            console.log(`当前手机号或邮箱未注册`)
                        } else {
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.account.errorTips[1]')
                        }
                    })
                    .catch(() => {
                        this.loginBtnState = false
                    })
            }
        },

        // 验证码登录
        codeLogin() {
            if (!this.isMobileSubmitDisabled && this.validateForm() && !this.loginBtnState) {
                this.loginBtnState = true
                let mobile = ''
                if (this.form.phone) {
                    // 去除手机号中的所有前导零
                    let cleanedPhone = this.form.phone.replace(/^0+/, '')
                    mobile = this.areaCode + cleanedPhone
                }
                this.$apollo
                    .query({
                        query: smsLogin,
                        fetchPolicy: 'network-only',
                        variables: {
                            mobile: mobile,
                            email: this.form.email,
                            code: String(this.form.code) || 0,
                            userId: this.userId,
                        },
                    })
                    .then((res) => {
                        const data = res.data.smsLogin
                        // 老用户 已有用户信息
                        if (data.code === 200) {
                            this.jumpReportPage(
                                { ...data.data, email: this.form.email, code: String(this.form.code) },
                                mobile
                            )
                        } else if (data.code === 413) {
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.rule.authCode.requiredMsg')
                        } else if (data.code === 404) {
                            this.loginBtnState = false
                            console.log(`当前手机号或邮箱未注册`)
                            this.toRegister()
                        } else {
                            this.loginBtnState = false
                            // 其他 登录失败
                            // this.erorTips = data.message
                            this.erorTips = this.$t('login.rule.phone.patternMsg')
                        }
                    })
                    .catch(() => {
                        this.loginBtnState = false
                    })
            }
        },

        thirdLoginClick(type) {
            if (!this.isSelectRule && type != 3) {
                this.$toast({
                    message: this.$t('register.check'),
                    duration: 2000,
                    className: 'success-toast',
                })
                return
            }
            let userId
            let scanId
            const query = this.$route.query || '/report'
            const urlObj = new URL(window.location.href)
            const redirectParam = urlObj.searchParams.get('redirect')
            if (redirectParam) {
                // 解码嵌套参数
                const nestedParams = new URLSearchParams(redirectParam.split('?')[1])
                userId = nestedParams.get('user_id')
                scanId = nestedParams.get('scan_id')
                this.userId = userId
            }
            const thirdToken = getCacheThirdToken(type)
            console.log('=========换取到的缓存token')
            console.log(thirdToken)
            if (thirdToken) {
                this.thirdLogin(`${type}`, thirdToken, query, userId)
                return
            }
            if (type === 1 || type === 2) {
                // 谷歌
                this.$apollo
                    .query({
                        query: getThirdLoginUrl,
                        fetchPolicy: 'network-only',
                        variables: {
                            type: `${type}`,
                            uri: 'login',
                        },
                    })
                    .then((res) => {
                        const data = res.data.getThirdLoginUrl
                        if (data && data.code === 200) {
                            const params = {
                                query: query,
                                type: `${type}`,
                                userId: userId,
                                scanId: scanId,
                            }
                            const state = Buffer.from(JSON.stringify(params)).toString('base64')
                            const url = `${data.data}&state=${encodeURIComponent(state)}`
                            console.log(`=======>url: ${url}`)
                            window.location.href = url
                        }
                    })
                    .catch(() => {
                        console.log('获取第三方登录链接')
                    })
            } else if (type === 3) {
                // 进入手机号登录
                this.$router.push({
                    path: '/phoneLogin',
                    query: this.$route.query, // 'to.fullPath'跳转到登录之前页面的路径
                })
            }
        },
        showPhoneLoginClick() {
            this.showPhoneLogin = !this.showPhoneLogin
        },

        thirdLogin(type, token, query, userId) {
            if (type === '1' || type === '2') {
                this.loading = true
                // 谷歌
                this.$apollo
                    .query({
                        query: thirdLogin,
                        fetchPolicy: 'network-only',
                        variables: {
                            type: `${type}`,
                            token: token,
                            userId: userId,
                        },
                    })
                    .then((res) => {
                        const data = res.data.thirdLogin
                        this.loading = false
                        if (data && data.code === 200) {
                            console.log(data)
                            checkEmailBound() // 标记首页检查是否绑定过邮箱
                            if (data.data && !data.data.token) {
                                // 第三方新首次登录
                                this.jumpBindPage({ ...data.data, ...query, userId })
                            } else {
                                this.jumpReportPage({ ...data.data, email: data.data.identifier })
                            }
                        } else if (data.code === 404) {
                            //  授权失败,无法获取账号信息
                            this.erorTips = this.$t('login.bindError[4]')
                            this.deleteThirdToken(type)
                        } else {
                            // 授权失败
                            this.erorTips = this.$t('login.bindError[3]')
                            this.deleteThirdToken(type)
                        }
                    })
                    .catch(() => {
                        this.loading = false
                        console.log('获取第三方登录链接')
                    })
            }
        },
        // 删除缓存的第三方授权token
        deleteThirdToken(type) {
            if (type === '1') {
                localStorage.setItem('appType_1', '')
            } else if (type === '2') {
                localStorage.setItem('appType_2', '')
            }
        },
        // 登录成功进入报告界面
        jumpReportPage(data, mobile) {
            console.log(mobile)
            window.localStorage.removeItem('modelInfo')
            window.localStorage.removeItem('lookUserInfo')
            window.localStorage.setItem(
                'loginInfo',
                JSON.stringify({
                    mobile: data.mobile,
                    email: data.email,
                })
            )
            // 保存token
            sessionStorage.setItem('token', data.token)
            // 下次自动登录
            if (this.isAutoLogin) {
                // 设置自动登录
                localStorage.setItem('token', data.token)
            }
            if (this.form.email && this.form.email.length > 0) {
                localStorage.setItem('email', this.form.email)
            } else if (data.email && data.email.length > 0) {
                localStorage.setItem('email', data.email)
            } else {
                localStorage.removeItem('email')
            }
            this.$toast({
                message: this.$t('login.loginSuccess'),
                duration: 1500,
                className: 'success-toast',
            })
            setTimeout(() => {
                this.loginBtnState = false
                console.log(data)
                if (data.password === 0 || data.password === '0') {
                    // 老用户没有密码引导设置密码
                    this.$router.push({
                        path: '/setPassword',
                        query: {
                            mobile: data.mobile,
                            email: data.email,
                            code: data.code,
                            areaCode: this.areaCode,
                            redirect: localStorage.getItem('redirect') || '/exception/report',
                            type: data.type === 1 || data.type == 2 ? 'thirdSetPassword' : 'bootSetupPassword',
                        },
                    })
                } else {
                    // 默认跳转到报告页面
                    let path = '/report'
                    // 如果是从别的页面跳转过来的，跳到之前的页面
                    if (localStorage.getItem('redirect')) {
                        path = localStorage.getItem('redirect') // 跳到之前的页面
                    }
                    this.$router.push({
                        path: path,
                    })
                }
            }, 2000)
        },
        // 进入绑定界面
        jumpBindPage(data) {
            window.localStorage.setItem('thirdLoginInfo', JSON.stringify(data))
            this.$router.push({
                path: '/boundConsultation',
                query: { redirect: localStorage.getItem('redirect') || '/exception/report' },
            })
        },

        // 判断验证码长度
        validatorCode() {
            const code = this.form.code.replace(/\s*/g, '')
            if (code.length > 4) {
                this.form.code = code.substring(0, 4)
            }
            this.mobileSubmitDisabled()
        },
        onCancel() {
            this.isToRegister = false
        },
        //账号不存在进入首页 并且带入邮箱或者账号
        toRegisterClick() {
            this.isToRegister = false
            this.loginStatus = false
        },
        // 去注册页面
        toRegister() {
            if (!this.form.email) {
                this.erorTips = this.$t('login.formList[2].label')
                return
            }
            // 去除手机号中的所有前导零
            let cleanedPhone = this.form.phone.replace(/^0+/, '')
            const userInfo = JSON.stringify({
                phone: cleanedPhone,
                code: this.form.code,
                email: this.form.email,
                countDownTime: this.countDownTime,
                areaCode: this.areaCode,
            })
            window.localStorage.setItem('lookUserInfo', userInfo)
            console.log(`开始存储 ${userInfo}`)
            // const phone = this.areaCode + this.form.phone
            this.$router.push({
                path: '/register',
                query: { redirect: localStorage.getItem('redirect') || '/exception/report' }, // 'to.fullPath'跳转到登录之前页面的路径
            })
        },
        // 忘记密码
        forgotPassword() {
            this.$router.push({
                path: '/resetPassword',
                query: { redirect: localStorage.getItem('redirect') || '/exception/report', type: 'forgotPassword' }, // 'to.fullPath'跳转到登录之前页面的路径
            })
        },
        findScanTypeInfoheightByScanId(scan_id) {
            let scanId = scan_id || this.scanId
            console.log(scanId, '>>>>>SCANID')
            if (scanId) {
                this.$apollo
                    .mutate({
                        mutation: findScanTypeInfoheightByScanId,
                        variables: {
                            scanId: scanId,
                        },
                    })
                    .then((res) => {
                        const data = res.data.findScanTypeInfoheightByScanId
                        if (data.code === 200) {
                            window.localStorage.setItem('ceheight', data.data.height)
                        }
                    })
                    .catch(() => {
                        console.log('error')
                    })
            }
        },
        getShareToken(url) {
            const arrUrl = url.split('&')
            localStorage.setItem('share', true)
            window.localStorage.removeItem('ceheight')
            if (arrUrl.length > 3) {
                this.loading = true
                sessionStorage.clear()
                localStorage.clear()
                // 7天分享链接为有
                let index = url.includes('type') ? 1 : 0
                const flag = Date.now() - arrUrl[3 + index].split('-')[0]

                if (flag < parseInt(shareTime) * 60 * 60 * 1000) {
                    const tokenId = index ? arrUrl[1] : arrUrl[0].split('?')[1]
                    this.$apollo
                        .query({
                            query: getMapToken,
                            fetchPolicy: 'network-only',
                            variables: {
                                tokenId: tokenId,
                            },
                        })
                        .then((res) => {
                            const data = res.data.getMapToken
                            console.log(data)
                            // 获取分享token成功
                            if (data.code === 200) {
                                const token = data.data || ''
                                sessionStorage.setItem('token', token)
                                localStorage.setItem('unit', arrUrl[1 + index])
                                localStorage.setItem('lang', arrUrl[2 + index])
                                localStorage.setItem('deviceType', arrUrl[3 + index].split('-')[1])
                                localStorage.setItem('share', false)
                                this.$i18n.locale = arrUrl[2 + index]
                                // 历史分享scanId
                                // console.log(arrUrl[5])
                                if (index) localStorage.setItem('shareScanId', arrUrl[5])

                                this.$router.push({
                                    path: url.includes('type') ? '/report?type=1' : '/report',
                                })
                            } else {
                                console.log('获取分享链接失败')
                            }
                        })
                        .catch((err) => {
                            console.error(err)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            }
        },
    },
}
</script>

<style scoped lang="less">
.register-page {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-top: 15px;
    background-image: linear-gradient(180deg, #262849, #07090f);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // justify-content: space-between;
    justify-content: initial;
    overflow: scroll;

    .loading-overlay {
        position: fixed; /* 覆盖整个视口 */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5); /* 可选：半透明遮罩 */
        z-index: 1000; /* 确保在最上层 */
    }

    .areaCode {
        z-index: 999;
    }

    .navbar {
        width: 100%;
        height: 30px;
        padding-right: 45px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .back {
            font-size: 12px;
            padding-left: 21px;
            color: #fff;
        }

        /deep/ .van-icon-arrow-left:before {
            font-size: 14px;
            color: #fff;
        }
    }

    .el-dropdown-language {
        font-size: 12px;
        color: #fff;

        &::after {
            content: '';
            position: absolute;
            top: 55%;
            right: -14px;
            transform: translateY(-80%);
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 30px;

        h2 {
            mix-blend-mode: initial;
            color: #ffffff;
            font-family: PingFangSC;
            font-size: 21px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.14;
            letter-spacing: normal;
            text-align: center;
            -webkit-background-clip: text;
            background-clip: text;
            // -webkit-text-fill-color: transparent;
        }

        p {
            width: 300px;
            height: 34px;
            font-family: PingFangSC;
            mix-blend-mode: initial;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: center;
            color: #8aa3be;
            margin-top: 15px;
            margin-bottom: 34px;
        }
    }

    /deep/ .content .form .item {
        input:-internal-autofill-previewed,
        input:-internal-autofill-selected {
            -webkit-text-fill-color: #ffffff !important;
            transition: background-color 5000s ease-in-out 0s !important;
        }
    }

    .content {
        // flex: 1;
        // 表单
        .form {
            width: 100%;
            height: auto;

            .item {
                width: 345px;
                height: 56px;
                margin: 0 auto;
                border-radius: 4px;
                // background-color: #232440;
                background: #303c5c;
                padding: 0 16px;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 8px;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.24);
                display: flex;
                align-items: center;
                box-sizing: border-box;

                .area {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .no {
                        margin-right: 7px;
                    }

                    .arrow_bottom {
                        width: 0;
                        height: 0;
                        border-left: 6px solid transparent;
                        border-right: 6px solid transparent;
                        border-top: 6px solid #fff;
                    }
                }

                .info {
                    position: relative;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    /deep/ .van-field {
                        padding-left: 0;
                        // background-color: #232440;
                        background: #303c5c;
                    }

                    /deep/ .van-field__control {
                        color: #fff;
                        margin-left: 30px;
                        padding-left: 0px;
                    }

                    /deep/ .van-field__control::placeholder {
                        color: #6c6c6f;
                        font-size: 13.5px;
                    }

                    &.center {
                        justify-content: center;
                    }

                    .over {
                        position: absolute;
                        z-index: 10;
                        width: 100%;
                        height: 56px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.5);
                        line-height: 56px;
                        // pointer-events: none;
                        background-color: #303c5c;
                    }

                    .toggle-password {
                        .eye-icon {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }

                label {
                    font-size: 14px;
                    text-align: left;
                }

                input {
                    width: 100%;
                    height: 56px;
                    background: transparent;
                    // padding-left: 46px;
                    font-size: 13px;
                    color: #fff;

                    &[name='birthday'] {
                        flex: none;
                        width: 50px;
                    }
                }

                .password-visible {
                    color: #fff;
                }

                .password-hidden {
                    //解决小米安全键盘回收留白底（防止调用安全键盘使用‘text’）
                    -webkit-text-security: disc;
                    text-security: disc;
                }

                /deep/ .van-field__control {
                    margin-left: 46px;
                }

                input[name='height'] ~ span {
                    font-size: 12px;
                    line-height: 12px;
                    color: rgba(255, 255, 255, 0.5);
                }

                .sex {
                    display: inline-block;
                    opacity: 0.5;
                    width: 40px;
                    height: 24px;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    margin: 0 20px;
                    border-radius: 4px;
                    border: 1px solid rgba(255, 255, 255, 1);

                    &.is-active {
                        opacity: 1;
                    }
                }

                .get-code-btn {
                    min-width: fit-content;
                    font-size: 12px;
                    color: #fff;

                    &.is-disabled {
                        opacity: 0.5;
                    }
                }
            }
        }
    }

    .footer {
        .login-tool {
            display: flex;
            width: 315px;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            margin-left: 14px;
            .left-view {
                width: 180px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                .name {
                    font-size: 12px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: #4a90e2;
                    margin-left: 5px;
                }
            }
            .name-view {
                width: 150px;
                font-size: 12px;
                font-family: PingFangSC;
                font-weight: 400;
                color: #4a90e2;
                margin-left: 5px;
                text-align: right;
            }

            .get-code-btn {
                width: 150px;
                text-align: right;
                font-size: 12px;
                color: #4a90e2;

                &.is-disabled {
                    opacity: 0.5;
                }
            }

            .image {
                width: 16px;
                height: 16px;
            }
        }

        .opacity {
            opacity: 0;
        }

        // 提交按钮
        .submit-btn {
            position: relative;
            margin-top: 32px;

            .error-tips {
                position: absolute;
                top: -25px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                color: #fe6363;
            }

            .create-account {
                text-align: center;
                font-size: 14px;
                color: #4a90e2;
                margin-top: 16px;
            }

            button {
                width: 200px;
                height: 40px;
                outline: none;
                border-radius: 6px;
                background-image: -webkit-gradient(linear, left top, right top, from(#00e3c9), to(#009fe8));
                background-image: -webkit-linear-gradient(left, #00e3c9, #009fe8);
                background-image: -o-linear-gradient(left, #00e3c9, #009fe8);
                background-image: linear-gradient(to right, #00e3c9, #009fe8);
                font-size: 16px;
                color: #fff;

                &.is-disabled {
                    border: 1px solid transparent;
                    background-image: linear-gradient(#191b31, #191b31),
                        /* 底色，即原有的背景 */ linear-gradient(to right, #06b0a2, #067eb9);
                    /* 模拟渐变边框 */
                    background-clip: padding-box, border-box;
                    background-origin: border-box;
                }

                .spinnerBtn {
                    display: flex;
                    justify-content: center;
                }

                /deep/ .mint-spinner-snake {
                    border: 2px solid transparent;
                }

                &.custom-btn {
                    width: 345px;
                    height: 40px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    border-radius: 6px;
                    margin-top: 20px;
                }
            }
        }
    }

    .automatic-login {
        color: #fff;
        height: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        margin-top: 18px;

        i {
            font-style: normal;
            color: #8aa3be;
        }

        .checkbox {
            position: relative;
            height: 14px;
            width: 14px;
            border-radius: 50%;
            margin-right: 5px;
            border: 1px solid #8aa3beff;

            input {
                height: 12px;
                width: 12px;
                border-radius: 50%;
                opacity: 0;
            }

            &.is-check {
                &:before {
                    position: relative;
                    content: '';
                    height: 14px;
                    width: 14px;
                    margin: -1px;
                    border-radius: 50%;
                    // background: #00a4e6;
                    display: block;
                    overflow: hidden;
                    background: url('../../assets/images/comp_rb.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }

        span {
            color: #4a90e2;
        }
    }

    .agreement {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        margin: 15px auto;
        width: 315px;
        height: auto;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
            font-style: normal;
            margin-right: 4px;
            color: #8aa3beff;
        }

        .checkbox {
            position: relative;
            height: 14px;
            width: 14px;
            border-radius: 50%;
            margin-right: 5px;
            border: 1px solid #8aa3beff;

            input {
                height: 14px;
                width: 14px;
                border-radius: 50%;
                opacity: 0;
                text-align: center;
            }

            &.is-check {
                &:before {
                    position: relative;
                    content: '';
                    height: 14px;
                    width: 14px;
                    left: -1px;
                    top: -1px;
                    margin: auto;
                    border-radius: 50%;
                    // background: #00a4e6;
                    display: block;
                    overflow: hidden;
                    background: url('../../assets/images/comp_rb.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }

        span {
            color: #4a90e2;
            z-index: 0;
            display: inline-block;
        }
        &.fi-FI {
            width: 330px;
            i {
                margin-right: 15px;
            }
        }
    }

    .third-view {
        display: flex;
        flex-direction: column;
        margin-top: 56px;
        .line-view {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .line {
                width: 100px;
                height: 1px;
                background-image: linear-gradient(
                    to right,
                    rgba(0, 227, 201, 0.2),
                    /* #00e3c9 透明度 20% */ rgba(0, 159, 232, 0.2) /* #009fe8 透明度 20% */
                );
            }
            .tips-view {
                font-size: 12px;
                color: #8aa3be;
                margin: 0 10px 0 10px;
            }
        }
        .third-login {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-top: 24px;
            .button {
                width: 48px;
                height: 48px;
            }
        }
    }

    .icon-del {
        float: right;
        width: 9.5px;
        height: 9.5px;
        border-radius: 0.8px;
        background: url('../../assets/images/register/register_phone_delete.png') no-repeat;
    }

    .tips {
        position: relative;
        display: inline-block;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        min-width: 10px;
        color: #ffffff;
        margin-bottom: 30px;

        &::before {
            content: '*';
            position: absolute;
            width: 5px;
            left: -8px;
            top: 2px;
        }
    }

    &.ja-JP {
        .header p {
            width: 225px;
            line-height: 17px;
        }

        .header {
            h2 {
                width: 168px;
            }
        }

        /deep/ .content .form .item {
            .get-code-btn {
                min-width: 60px;
                text-align: left;
            }
        }

        /deep/ .item:nth-child(2) {
            .van-field__control {
                margin-left: 22px;
            }
        }

        /deep/ input[name='verifyPassword'] {
            width: 104px;
            line-height: 20px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
        }

        div .error-tips {
            width: 314px;
            height: 34px;
        }

        /deep/ .van-cell__value {
            margin-left: 0px;
            text-align: left;
        }

        .custom-btn {
            margin-top: 10px !important;
        }
    }

    &.en-US,
    &.it-IT,
    &.fr-FR,
    &.ru-RU,
    &.es-ES,
    &.pt-PT,
    &.cs-CZ,
    &.tr-TR,
    &.sv-SE,
    &.el-GR,
    &.hu-HU,
    &.de-DE {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }
    }
    &.es-ES,
    &.pt-PT {
        .codeLabel {
            width: 70px;
        }
    }

    &.el-GR {
        .form .item input {
            font-size: 12px;
        }
        .header {
            h2 {
                font-family: Helvetica;
            }
            p {
                font-family: Helvetica;
            }
        }
        .footer {
            .login-tool {
                .left-view .name {
                    font-family: Helvetica;
                }
                .name-view {
                    font-family: Helvetica;
                }
                .get-code-btn {
                    font-family: Helvetica;
                }
            }
        }
    }

    &.pt-PTO {
        .codeLabel-item {
            width: 80px;
        }
    }

    &.de-DE {
        .codeLabel {
            width: 70px;
        }
    }

    &.ar-AR {
        direction: rtl;

        .iteminput {
            direction: ltr;
        }

        .itemyzm {
            direction: ltr;
            text-align: right;
        }

        .header {
            p {
                text-align: right;
            }
        }

        .search {
            padding-right: 10px;
        }

        /deep/.el-dropdown {
            margin-left: 20px;
        }

        /deep/.van-field__control {
            text-align: right;
        }

        .content .form .item input,
        .footer .rule i,
        .content .form .item .area .arrow_bottom {
            margin-right: 10px;
        }

        .footer .login-tool {
            margin-right: 14px;
        }

        .footer .login-tool .name-view {
            text-align: left;
            margin-left: 0px;
        }

        .footer .login-tool .get-code-btn {
            text-align: left;
        }

        .agreement .checkbox {
            margin-left: 5px;
            margin-right: 0;
            &.is-check {
                &:before {
                    left: 1px;
                    top: -1px;
                    margin: auto;
                    border-radius: 50%;
                    // background: #00a4e6;
                    display: block;
                    overflow: hidden;
                    background: url('../../assets/images/comp_rb.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .agreement i {
            margin-left: 4px;
            margin-right: 0;
        }

        .item .info .van-field__body {
            direction: ltr;
        }
        .right-text-left {
            margin-left: 10px;
        }
        .automatic-login {
            .checkbox {
                margin-left: 5px;
                margin-right: 0;
            }
        }
    }
    &.hu-HU,
    &.sv-SE {
        .content .item {
            padding-right: 0;
        }
        .get-code-btn {
            min-width: 40px !important;
        }
    }

    &.vi-VN {
        .left-view {
            width: 250px !important;
        }

        .line-view .line {
            width: 80px !important;
        }
    }
    &.pl-PL {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }

        .content .form .item > label.codeLabel.codeLabel-item {
            width: max-content !important;
            min-width: 120px !important;
            max-width: none !important;
            flex: 0 0 auto !important;
            flex-shrink: 0 !important;
            white-space: nowrap !important;
            box-sizing: border-box;
        }
    }
}

.dialog {
    /deep/ .van-dialog {
        width: 290px;
        background-color: #e7e7e7;
        padding: 20px;
        padding-top: 0;
        .tips {
            margin-top: 15px;
            p {
                margin-bottom: 15px;
                text-align: center;
                font-size: 14px;
                line-height: 18px;
                color: #111111ff;
                margin: 0 18 px;
            }
        }

        .btns {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin-top: 25px;
            .dialog-cancel {
                width: 100px;
                height: 33px;
                color: #000;
                margin-right: 15px;
                background: url(../../assets/images/login/bind_email_bg.png) no-repeat center center / cover;
            }
            .dialog-confirm {
                color: #000;
                width: 100px;
                height: 33px;
                background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                border-radius: 5px;
                // border: 1px solid transparent;
                // border-image: linear-gradient(90deg, rgba(0, 227, 201, 1), rgba(0, 159, 232, 1)) 1 1;
            }
        }
    }
}
</style>
<style>
/deep/.register-page {
    background-image: linear-gradient(180deg, #262849, #07090f) !important;
}

input[type='number'] {
    -moz-appearance: textfield;
}

input:-webkit-autofill {
    box-shadow: 0 0 0 1000px #303c5c inset;
    -webkit-text-fill-color: #fff;
}

input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    -webkit-text-fill-color: #303c5c;
    transition: background-color 5000s ease-out 0.5s;
}

::-webkit-input-placeholder {
    color: #6c6c6f;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #6c6c6f;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: #6c6c6f;
}

:-moz-placeholder {
    color: #6c6c6f;
}
</style>
